import React from 'react';
import { useNavigate } from 'react-router';

import Logo from '../Components/Logo';

import styles from '../styles/DynamicModal.module.css';
import stylesLogo from '../styles/Logo.module.css';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';
import { ReactComponent as CheckCircleInfo } from '../icons/check-circle.svg';
import { ReactComponent as XCircleInfo } from '../icons/x-circle.svg';

const closeModal = () => {
  window.location.href = '/';
};

const verifiedEmails = [
    'info@alians009.ru',
    'otbor@alians009.ru',
    'legal@alians009.ru',
    'control@alians009.ru',
    'rule@alians009.ru',
    'shcheaa@icloud.com',
];

export default function EmailAuthentication() {
    const navigate = useNavigate();

    const [loading, setLoading] = React.useState(false);
    const [status, setStatus] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [isSuccess, setIsSuccess] = React.useState(false);

    const handleCheck = () => {
        const trimmedEmail = email.trim().replace(/^<\s*|\s*>$/g, '');

        if (!trimmedEmail) {
            setStatus('Введите email для проверки');
            return;
        }

        const isVerified = verifiedEmails.includes(trimmedEmail);

        setStatus(
            isVerified
                ? 'Адрес подтверждён — это официальный email СРО'
                : 'Адрес не найден в списке официальных email СРО. Будьте осторожны, это может быть мошенничество. Если вы получили письмо с этого адреса, не выполняйте указанные в нём действия и уточните информацию напрямую в СРО по телефону с официального сайта.'
        );
        setIsSuccess(
            isVerified
                ? true
                : false
        );
        setIsShowSuccessScreen(true);
    };

    const [isShowSuccessScreen, setIsShowSuccessScreen] = React.useState(false);

    return (
        <>
            <a style={{zIndex: '9999'}} className={stylesLogo.widthLimitation}><Logo to='/' position='fixed' /></a>
            <div className={styles.liningOver} style={{ backgroundColor: '#00000000' }}>
                <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                    {!isShowSuccessScreen ?
                    <>
                    <div className={styles.header}>
                        <h1>Проверка подлинности адреса электронной почты Союза «СОАУ «Альянс»</h1>
                        <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                    </div>
                    <div className={styles.main}>
                        <p className='description'>Если Вы сомневаетесь в подлинности письма, которое якобы пришло от СРО, скопируйте адрес электронной почты отправителя письма и вставьте в поле ниже, чтобы проверить, принадлежит ли адрес СРО.</p>
                        <div className='labelInputWrapper'>
                            <a className='label'>Введите email, с которого пришло письмо</a>
                            <div className='labelInputRight'>
                                <div className='inputWrapper'>
                                    <input 
                                    type='text' 
                                    value={email} 
                                    onChange={(e) => setEmail(e.target.value)} 
                                    placeholder='Например, info@example.com' 
                                    minLength='' 
                                    maxLength='50' 
                                    disabled={loading}
                                    required />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.bottom}>
                        <div></div>
                        <button 
                            type='button' 
                            className='button' 
                            onClick={handleCheck}
                            disabled={loading}
                        >
                            Проверить
                        </button>
                    </div>
                    </>
                    :
                    <>
                    <div className={styles.header}>
                        <h1>{isSuccess ? 'Результат проверки' : 'Обратите внимание'}</h1>
                        {closeModal && <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />}
                    </div>
                    <div className={styles.main}>
                        <IconContainer Icon={isSuccess ? CheckCircleInfo : XCircleInfo} isClickable={false} onClick={() => {}} size = '30' color = {isSuccess ? '#0a9f3c' : 'red'} className = '' />
                        <h1>{isSuccess ? 'Адрес подтверждён' : 'Адрес не подтверждён'}</h1>
                        <p style={{fontSize: '14px'}}>{status}</p>
                        <div style={{height: '40px'}}></div>
                        <button
                            type='button'
                            className='button'
                            onClick={() => {
                                setIsShowSuccessScreen(false);
                                setEmail('');
                                setStatus('');
                            }}
                        >
                            Проверить другой адрес
                        </button>
                    </div>
                    </>}
                </div>
            </div>
        </>
    );
};